module.exports = __webpack_public_path__ + "img/logo.9cc8db30.jpg";